/**
 * Shared `Intl.NumberFormat` helpers for metric components (StatCard,
 * DeltaIndicator, BarList). Currency goes through Money's `formatMoney`
 * in the component, never here.
 */
/** Formats `value` with `Intl.NumberFormat`. Percent defaults to at most one decimal. */
export function formatNumber(value, opts = {}) {
    const { kind = 'number', locale, notation = 'standard', options } = opts;
    const base = kind === 'percent' ? { style: 'percent', maximumFractionDigits: 1 } : {};
    return new Intl.NumberFormat(locale, { ...base, notation, ...options }).format(value);
}
/**
 * A part of a whole as a percentage: `formatShare(3, 40)` is "8%". A non-zero
 * share under 1% is written "<1%", and one over 99% that is not the whole
 * is ">99%", so rounding never hides a segment.
 */
export function formatShare(part, total, opts = {}) {
    const digits = opts.maximumFractionDigits ?? 0;
    const pct = (n) => formatNumber(n, {
        kind: 'percent',
        ...(opts.locale !== undefined && { locale: opts.locale }),
        options: { maximumFractionDigits: digits, minimumFractionDigits: 0 },
    });
    if (!(total > 0) || !(part > 0))
        return pct(0);
    const ratio = part / total;
    const step = 10 ** -(digits + 2);
    if (ratio < step)
        return `<${pct(step)}`;
    if (ratio < 1 && ratio > 1 - step)
        return `>${pct(1 - step)}`;
    return pct(ratio);
}
//# sourceMappingURL=format-number.js.map